import React, { type FC } from "react";
import { withPrefix } from "@tracking/tracking";
import { useTrackElement } from "@edreamsodigeo/frontend-core";

export const ERROR_ORIGIN = {
  render_got: "render_got",
  render_google_button: "render_google_button",
  hide_got: "hide_got",
  initialize: "initialize",
  select_by: "select_by",
};

interface TrackingErrorComponentProps {
  trackingPrefix?: string;
}

export const TrackingErrorComponent: FC<TrackingErrorComponentProps> = ({
  trackingPrefix,
}) => {
  const trackingRenderGotError = useTrackElement(
    ["click"],
    withPrefix("ERROR_" + ERROR_ORIGIN.render_got, trackingPrefix),
  );
  const trackingRenderGoogleButtonError = useTrackElement(
    ["click"],
    withPrefix("ERROR_" + ERROR_ORIGIN.render_google_button, trackingPrefix),
  );
  const trackingHideGotError = useTrackElement(
    ["click"],
    withPrefix("ERROR_" + ERROR_ORIGIN.hide_got, trackingPrefix),
  );
  const trackingInitializeError = useTrackElement(
    ["click"],
    withPrefix("ERROR_" + ERROR_ORIGIN.initialize, trackingPrefix),
  );

  const trackingSelectByError = useTrackElement(
    ["click"],
    withPrefix("ERROR_" + ERROR_ORIGIN.select_by, trackingPrefix),
  );

  return (
    <>
      <span
        ref={trackingRenderGotError}
        data-testid={ERROR_ORIGIN.render_got}
        id={ERROR_ORIGIN.render_got}
      />
      <span
        ref={trackingRenderGoogleButtonError}
        data-testid={ERROR_ORIGIN.render_google_button}
        id={ERROR_ORIGIN.render_google_button}
      />
      <span
        ref={trackingHideGotError}
        data-testid={ERROR_ORIGIN.hide_got}
        id={ERROR_ORIGIN.hide_got}
      />
      <span
        ref={trackingInitializeError}
        data-testid={ERROR_ORIGIN.initialize}
        id={ERROR_ORIGIN.initialize}
      />
      <span
        ref={trackingSelectByError}
        data-testid={ERROR_ORIGIN.select_by}
        id={ERROR_ORIGIN.select_by}
      />
    </>
  );
};
